import type { CategoryPriceHistoryEntry } from '@/entities/category';

/** Подпись источника в «Истории цены» (§2.1). «Откат» — приход, из которого была взята цена,
 * перестал действовать (снят с проведения, отменён, удалён, строка перенесена в другой товар), и
 * цена вернулась к предыдущему источнику. */
export function priceSourceLabel(after: CategoryPriceHistoryEntry['after']): string {
  if (after.source === 'PURCHASE') return `Приход ${after.documentNumber ?? ''}`.trim();
  if (after.source === 'ROLLBACK') {
    if (after.restoredFrom === 'PURCHASE') return `Откат к приходу ${after.documentNumber ?? ''}`.trim();
    if (after.restoredFrom === 'MANUAL') return 'Откат к ручной цене';
    return 'Откат: приходов с ценой не осталось';
  }
  return 'Вручную';
}
